export default [
    // Billboard images and their websites.
    // Edit each image's path and url here; moving its whole entry keeps the pair together.
    // Textures with a url become billboards. Other resources can omit url.
    {
        name: 'astanaexpo',
        type: 'texture',
        path: '/textures/works/astanaexpo.jpg',
        url: 'https://jmayerh.de/astana-expo-2017/'
    },
    {
        name: 'etb',
        type: 'texture',
        path: '/textures/works/etb.jpg',
        url: 'https://jmayerh.de/extension-on-top-of-the-kleine-grosz-museum-at-tankstelle-bulowstrasse/'
    },
    {
        name: 'freiburg',
        type: 'texture',
        path: '/textures/works/freiburg.jpg',
        url: 'https://jmayerh.de/pavilion-on-europaplatz/'
    },
    {
        name: 'kehl',
        type: 'texture',
        path: '/textures/works/kehl.jpg',
        url: 'https://jmayerh.de/tram-stop/'
    },
    {
        name: 'moscase1',
        type: 'texture',
        path: '/textures/works/moscase1.jpg',
        url: 'http://moscase.com'
    },
    {
        name: 'moscase2',
        type: 'texture',
        path: '/textures/works/moscase2.jpg',
        url: 'http://moscase.com'
    },
    {
        name: 'nn',
        type: 'texture',
        path: '/textures/works/nn.jpg',
        url: 'https://jmayerh.de/n-n-residence-near-moscow/'
    },
    {
        name: 'pavilionkarsruhe',
        type: 'texture',
        path: '/textures/works/pavilionkarsruhe.jpg',
        url: 'https://jmayerh.de/pavilion-ka300/'
    },
    {
        name: 'petriplatz',
        type: 'texture',
        path: '/textures/works/petriplatz.jpg',
        url: 'https://jmayerh.de/house-of-prayer-and-learning/'
    },
    {
        name: 'photography',
        type: 'texture',
        path: '/textures/works/photography.jpg',
        url: 'https://www.instagram.com/superb.berlin/'
    },
    {
        name: 'raw',
        type: 'texture',
        path: '/textures/works/raw.jpg',
        url: 'https://jmayerh.de/raw/'
    },
    {
        name: 'rkm',
        type: 'texture',
        path: '/textures/works/rkm.jpg',
        url: 'https://jmayerh.de/zipper-rkm-740/'
    },
    {
        name: 'tischtennis',
        type: 'texture',
        path: '/textures/works/tischtennis.jpg',
        url: 'https://jmayerh.de/table-tennis-table/?n=1861'
    },
    {
        name: 'waldsee',
        type: 'texture',
        path: '/textures/works/waldsee.jpg',
        url: 'https://jmayerh.de/strukturalien/'
    },
    {
        name: 'warhammer',
        type: 'texture',
        path: '/textures/works/warhammer.jpg',
        url: 'https://www.instagram.com/superb.berlin/'
    },
    {
        name: 'woodworking',
        type: 'texture',
        path: '/textures/works/woodworking.jpg',
        url: 'https://www.youtube.com/watch?v=hs4sur3MTwM&t=12s'
    },
]
